<template>
  <div>
    <InfoAlert :inline="true" type="news" />
    <TopNewsMenu />
    <CarouselBanner type="news" />
    <div name="grid" class="flex justify-center mx-auto">
      <CategoryDropdownSidebar :type="CATEGORY_TYPE.NEWS" />
      <main class="flex-1 sm:flex-none">
        <NewsFeed />
      </main>
    </div>
  </div>
</template>

<script setup>
import { CATEGORY_TYPE } from "@utils/constants";
import { ROUTES } from "@utils/routes";
import { sitePages } from "@settings/site-pages.settings";
import CarouselBanner from "@components/common/carousel-banner";
import CategoryDropdownSidebar from "@components/category/category-dropdown-sidebar";
import NewsFeed from "@components/news/news-feed";
import TopNewsMenu from "@components/category/top-news-menu";

definePageMeta({
  layout: 'shop-layout'
});

defineI18nRoute({
  paths: {
    cs: '/novinky',
    en: '/news',
    sk: '/novinky',
    pl: '/nowosc',
    de: '/nachrichten'
  }
});

const { t } = useI18n();
const config = useRuntimeConfig();
const canonical = config.public.appBaseUrl + translatePath(ROUTES.CODE.NEWS);
const { title: seoTitle, ogUrl } = useFilterSeoTitle(() => t(sitePages[config.public.layoutDesign].news[0].heading));

useHead({ link: [ { rel: 'canonical', href: canonical } ] });
useSeoMeta({
  title: () => seoTitle.value,
  ogTitle: () => seoTitle.value,
  description: t(sitePages[config.public.layoutDesign].news[0].subheading).replace('<br>', ' '),
  ogDescription: t(sitePages[config.public.layoutDesign].news[0].subheading).replace('<br>', ' '),
  ogImage: `${config.public.appBaseUrl}${sitePages[config.public.layoutDesign].news[0].image}`,
  ogType: `${sitePages[config.public.layoutDesign].type}`,
  ogUrl: () => ogUrl.value
});

</script>
